import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactTags from 'react-tagsinput';
import translate from '../../translate';
import Notifications from '../../../services/notifications';

function TagsInput(props) {
  const { t, id, name, placeholder, onChange, disabled, value, className, validationRegex, onValidationReject, keysToAdd } = props;

  const [inputValue, setInputValue] = useState('');

  const handleInputChange = e => {
    setInputValue(e.target.value);
  };

  const validateAndAddTag = tag => {
    if (tag && tag.trim()) {
      if (validationRegex.test(tag)) {
        onChange([...value, tag.trim()]);
        setInputValue('');
        return true;
      } if (onValidationReject) {
        onValidationReject(tag);
      }
      Notifications.showNotificationError(t('error'), t('error.tag'));
      return false;
    }
    return false;
  };

  const handleAddTag = () => {
    validateAndAddTag(inputValue);
  };

  const handleChange = tags => {
    // This will be called when tags are added/removed via keyboard
    if (tags.length > value.length) {
      // A new tag was added
      const newTag = tags[tags.length - 1];
      if (validateAndAddTag(newTag)) {
        setInputValue(''); // Clear input after successful keyboard addition
      }
    } else {
      // Tag was removed or other change
      onChange(tags);
    }
  };

  return (
    <div className="tags-input-container">
      <ReactTags
        id={id}
        name={name}
        value={value || []}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        addKeys={keysToAdd}
        validationRegex={validationRegex}
        onValidationReject={onValidationReject}
        inputProps={{
          placeholder,
          className: `react-tagsinput-input ${className}`,
          onChange: handleInputChange,
          value: inputValue,
        }}
      />
      <button
        type="button"
        onClick={handleAddTag}
        disabled={disabled || !inputValue.trim()}
        className="tags-input-button"
      >
        <i className="fa fa-plus" />
      </button>
    </div>
  );
}

TagsInput.propTypes = {
  /** Selector id used by the jQuery libraries */
  id: PropTypes.string.isRequired,
  /** Selector html name, required for validation */
  name: PropTypes.string,
  /** Class names to be added to the default ones */
  className: PropTypes.string,
  /** initial value */
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** onChange handler */
  onChange: PropTypes.func.isRequired,
  /** Custom placeholder text */
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  validationRegex: PropTypes.instanceOf(RegExp),
  onValidationReject: PropTypes.func,
  /** Select custom keys to add tag, or use the default in prop type */
  keysToAdd: PropTypes.arrayOf(PropTypes.number),
};

TagsInput.defaultProps = {
  name: null,
  className: '',
  placeholder: undefined,
  disabled: false,
  validationRegex: /.*/,
  onValidationReject: null,
  keysToAdd: [9, 13, 188], // tab, enter, comma
};

export default translate(TagsInput);
